import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import "./chunk-PXG64RU4.js"; // src/retryer.ts

import { focusManager } from "./focusManager.js";
import { onlineManager } from "./onlineManager.js";
import { pendingThenable } from "./thenable.js";
import { isServer, sleep } from "./utils.js";

function defaultRetryDelay(failureCount) {
  return Math.min(1e3 * Math.pow(2, failureCount), 3e4);
}

function canFetch(networkMode) {
  return (networkMode !== null && networkMode !== void 0 ? networkMode : "online") === "online" ? onlineManager.isOnline() : true;
}

var CancelledError = /*#__PURE__*/function (_Error) {
  function CancelledError(options) {
    var _this2;

    _classCallCheck(this, CancelledError);

    _this2 = _callSuper(this, CancelledError, ["CancelledError"]);
    _this2.revert = options == null ? void 0 : options.revert;
    _this2.silent = options == null ? void 0 : options.silent;
    return _this2;
  }

  _inherits(CancelledError, _Error);

  return _createClass(CancelledError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function isCancelledError(value) {
  return value instanceof CancelledError;
}

function createRetryer(config) {
  var isRetryCancelled = false;
  var failureCount = 0;
  var isResolved = false;
  var continueFn;
  var thenable = pendingThenable();

  var cancel = function cancel(cancelOptions) {
    var _a;

    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      (_a = config.abort) == null ? void 0 : _a.call(config);
    }
  };

  var cancelRetry = function cancelRetry() {
    isRetryCancelled = true;
  };

  var continueRetry = function continueRetry() {
    isRetryCancelled = false;
  };

  var canContinue = function canContinue() {
    return focusManager.isFocused() && (config.networkMode === "always" || onlineManager.isOnline()) && config.canRun();
  };

  var canStart = function canStart() {
    return canFetch(config.networkMode) && config.canRun();
  };

  var resolve = function resolve(value) {
    var _a;

    if (!isResolved) {
      isResolved = true;
      (_a = config.onSuccess) == null ? void 0 : _a.call(config, value);
      continueFn == null ? void 0 : continueFn();
      thenable.resolve(value);
    }
  };

  var reject = function reject(value) {
    var _a;

    if (!isResolved) {
      isResolved = true;
      (_a = config.onError) == null ? void 0 : _a.call(config, value);
      continueFn == null ? void 0 : continueFn();
      thenable.reject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      var _a;

      continueFn = function continueFn(value) {
        if (isResolved || canContinue()) {
          continueResolve(value);
        }
      };

      (_a = config.onPause) == null ? void 0 : _a.call(config);
    }).then(function () {
      var _a;

      continueFn = void 0;

      if (!isResolved) {
        (_a = config.onContinue) == null ? void 0 : _a.call(config);
      }
    });
  };

  var _run = function run() {
    if (isResolved) {
      return;
    }

    var promiseOrValue;
    var initialPromise = failureCount === 0 ? config.initialPromise : void 0;

    try {
      promiseOrValue = initialPromise !== null && initialPromise !== void 0 ? initialPromise : config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }

    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      var _a;

      if (isResolved) {
        return;
      }

      var retry = (_config$retry = config.retry) !== null && _config$retry !== void 0 ? _config$retry : isServer ? 0 : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) !== null && _config$retryDelay !== void 0 ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);

      if (isRetryCancelled || !shouldRetry) {
        reject(error);
        return;
      }

      failureCount++;
      (_a = config.onFail) == null ? void 0 : _a.call(config, failureCount, error);
      sleep(delay).then(function () {
        return canContinue() ? void 0 : pause();
      }).then(function () {
        if (isRetryCancelled) {
          reject(error);
        } else {
          _run();
        }
      });
    });
  };

  return {
    promise: thenable,
    cancel: cancel,
    continue: function _continue() {
      continueFn == null ? void 0 : continueFn();
      return thenable;
    },
    cancelRetry: cancelRetry,
    continueRetry: continueRetry,
    canStart: canStart,
    start: function start() {
      if (canStart()) {
        _run();
      } else {
        pause().then(_run);
      }

      return thenable;
    }
  };
}

export { CancelledError, canFetch, createRetryer, isCancelledError };